import {Component} from '@angular/core';
import {Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {LoginPage} from "../pages/login/login";
import {AccountProvider} from '../providers/account/account';
import {TranslateService} from "@ngx-translate/core";
import {DemoPage} from "../pages/demo/demo";
import {HomePage} from "../pages/home/home";

@Component({
    templateUrl: 'app.html',
    providers: [AccountProvider,]
})
export class MyApp {
    rootPage: any = LoginPage;

    constructor(platform: Platform,
                statusBar: StatusBar,
                splashScreen: SplashScreen,
                public translate: TranslateService,
                public accountProvider: AccountProvider) {

        this.clearParent();
        this.loadLanguages();

        if (window.localStorage.getItem('TOKEN_KEY') === 'demo') {
            this.rootPage = DemoPage;
        } else if (window.localStorage.getItem('TOKEN_KEY')) {
            this.rootPage = HomePage;
        }

        platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            statusBar.styleDefault();
            splashScreen.hide();
        });

        if (window.localStorage.getItem('TOKEN_KEY') !== 'demo') {
            this.loadProfile();
        }
    }

    loadLanguages() {
        const currentLanguage = window.localStorage.getItem('LANG') || 'vi';

        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang(currentLanguage);

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use(currentLanguage);
    }

    loadProfile() {
        this.accountProvider.loadProfile().subscribe((resp: any) => {
            if (!resp.status) {
                this.rootPage = LoginPage;
            }
        }, err => {
            this.rootPage = LoginPage;
        });
    }

    clearParent() {
        window.localStorage.removeItem('PARENT_MODE');
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts